// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsInt, ValidateNested, IsArray } from 'class-validator';

export class Civil3dMapping {
  @IsInt()
  civil3dPropertyId: number;

  @IsInt()
  attributeId: number;
}

export class PropertyMappingForm {
  @IsArray()
  @ValidateNested({ each: true })
  propertyMappings: Civil3dMapping[];
}
